export const SET_SHIFTPLAN = 'setShiftplan';
export const SET_SLOT_DISPLAY_STYLE = 'setSlotDisplayStyle';
export const SET_FREE_RANGE_INTERVAL = 'setFreeRangeInterval';
export const SET_TIMEFRAME = 'setTimeframe';
